import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ErrorService } from '../../error';
import { ClaimTypeModel } from './types';
import { catchError } from 'rxjs/operators';
import { CrudType } from '../../service/message/types';
import { MessageService } from '../../service/message/message.service';

@Injectable({
  providedIn: 'root',
})
export class ClaimTypeApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
    private readonly messageService: MessageService,
  ) {}

  getById = (id: number): Observable<ClaimTypeModel> => {
    let url = this.formatUrl([id.toString()]);
    return this.httpClient.get<ClaimTypeModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  createInstance = (): Observable<ClaimTypeModel> => {
    let url = this.formatUrl(['create']);
    return this.httpClient.get<ClaimTypeModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  add = (claimTypeModel: ClaimTypeModel): Observable<ClaimTypeModel> => {
    let url = this.formatUrl([]);
    return this.httpClient
      .post<ClaimTypeModel>(url, claimTypeModel, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.create),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  update = (claimTypeModel: ClaimTypeModel): Observable<ClaimTypeModel> => {
    let url = this.formatUrl([claimTypeModel.id.toString()]);
    return this.httpClient
      .put<ClaimTypeModel>(url, claimTypeModel, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.update),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  delete = (id: number): Observable<boolean> => {
    let url = this.formatUrl([id.toString()]);
    return this.httpClient.delete<boolean>(url, { observe: 'response' }).pipe(
      this.messageService.checkStatusCustomOperator(CrudType.delete),
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.claimType.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
